import React, { useState, useEffect } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useNavigate } from 'react-router-dom';
import { useContextData } from '../ContextData';
import { useIsMobile } from '../../helpers/customHooks';
import axios from 'axios';
import SafetyZoneMap from '../Map/SafetyZoneMap';
import NewButton from '../Buttons/NewButton';


const ZoneModal = ({ show, device, activateAlarm, deactivateAlarm, onClose }) => {
    const MOBILE = useIsMobile();
    const navigate = useNavigate()
    const { t } = useTranslation();

    const alarmcenter = device?.alarmcenter
    const center = alarmcenter?.name
    const triggered = alarmcenter?.triggered
    const armed = alarmcenter?.armed
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={onClose}>
            <Card className="settings-dialog d-flex flex-column grey-blue scrollable-y">
                <div className="w-100 h-100 grey-blue">
                    <div className="p-3">
                            <div className="d-flex flex-row justify-content-between align-items-center">
                                <div className='d-flex align-items-center'>
                                    <h3 className="">{t("devices.arm_zone")}</h3>
                                </div>
                                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                            </div>
                                {triggered || armed
                                ?
                                <>
                                <p>{t("devices.arm_zone_body_deactivate", {central: center})}</p>

                                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("devices.cancel")}</NewButton>
                                    <NewButton onClick={() => deactivateAlarm()} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("devices.deactivate")}</NewButton>
                                </div>
                                </>
                                :
                                <>
                                <div className="p-3">
                                    <p>{t("devices.arm_zone_body", {central: center})}</p>
                                    <div className="shadow-sm border-12 safety-map-border mt-3" style={{width: "auto", height: "200px"}}>
                                        <SafetyZoneMap device={device}/>
                                    </div>
                                </div>
                                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("devices.cancel")}</NewButton>
                                    <NewButton onClick={() => activateAlarm()} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("devices.confirm")}</NewButton>
                                </div>
                                </>
                            }
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default ZoneModal;